import { Device } from '@cardsjd/device';

export default class EmailFeedback {
	constructor(options) {
		this.appName = options.appName || 'App';
		this.email = options.email || 'jimmy@jdsoftwarellc.com';
		this.emailSubject = options.emailSubject || `${this.appName} Feedback`;
		this.os = options.os || this.getPlatform();
		this.version = options.version || '';
	}

	send(userdata) {

		const appName = this.appName;
		const os = this.os.substring(0, 3);
		const email = this.email;
		const emailSubject = this.emailSubject;
		const version = this.version;
		const userId = userdata?.id ?? '';

		const url = encodeURI(`mailto:${email}?subject=${appName} ${version}-${os.substring(0, 2)} ${emailSubject} ${userId} &body=`);
		window.open(url, '_system');
	}
	getPlatform() {
		const device = new Device();
		return device.getPlatform();
	}
}
